import WoSectionCard from "../common/WoSectionCard";
import Timesheet from "./Timesheet";

// Timesheet section as an independent card matching the proposals/forms look.
function WoTimesheet({ order }) {
  return (
    <WoSectionCard title="Timesheet">
      <Timesheet order={order} />
    </WoSectionCard>
  );
}

export default WoTimesheet;
